// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/flaps.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/flaps/flap-effects-and-retraction.js';
import g1 from '../lessons/aeronautics/flaps/flaps.js';

mount([g0, g1]);
